import React from 'react';

import { Alert, Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import ScopeCell from './ScopeCell';
import { SCOPE_SOURCE_LABEL, getRoomsScopeChipColor } from './blackoutScopeClassifier';
import type { RoomTypeBlackoutPlan } from './buildBlackoutApplyPlan';

interface Props {
  changedPlans: Array<RoomTypeBlackoutPlan>;
  excludedRoomTypeIds: Set<string>;
  showScopeColumn: boolean;
  toggleRoomType: (roomTypeId: string, checked: boolean) => void;
}

export default function BlackoutApplyReviewTable({
  changedPlans,
  excludedRoomTypeIds,
  showScopeColumn,
  toggleRoomType,
}: Props) {
  if (changedPlans.length === 0) {
    return <Alert severity="info">All room rates already match this source. There is nothing to apply.</Alert>;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox" />
          <TableCell>Room type</TableCell>
          {showScopeColumn && <TableCell>Room scope</TableCell>}
          <TableCell align="right">To create</TableCell>
          <TableCell align="right">To remove</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {changedPlans.map((plan) => (
          <TableRow key={plan.roomTypeId}>
            <TableCell padding="checkbox">
              <Checkbox
                checked={!excludedRoomTypeIds.has(plan.roomTypeId)}
                onChange={(event) => toggleRoomType(plan.roomTypeId, event.target.checked)}
              />
            </TableCell>
            <TableCell>{plan.roomTypeName}</TableCell>
            {showScopeColumn && (
              <TableCell>
                <ScopeCell
                  color={getRoomsScopeChipColor({
                    matchedRooms: [],
                    scope: plan.scopeSource === 'needs_review' ? 'only' : 'all',
                    source: plan.scopeSource,
                  })}
                  tooltip={SCOPE_SOURCE_LABEL[plan.scopeSource]}
                  value={SCOPE_SOURCE_LABEL[plan.scopeSource]}
                />
              </TableCell>
            )}
            <TableCell align="right">{plan.rangesToCreate.length}</TableCell>
            <TableCell align="right">{plan.blocksToDelete.length}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
